import React from 'react';
import { StyleSheet } from 'react-native';
import PressableStyled from './PressableStyled';
import ColumnsIcon12 from './12pxIcons/ColumnsIcon12';
import Colors from '../constants/Colors';

interface ColumnsButtonProps {
  onPress: () => void;
}

const ColumnsButton = ({ onPress }: ColumnsButtonProps) => <PressableStyled
  style={styles.container}
  children={<ColumnsIcon12 />}
  {...{ onPress }}
/>;

const styles = StyleSheet.create({
  container: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 4,
    borderColor: Colors.light.hereworksBlue100,
  },
});

export default ColumnsButton;
